import React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

export default function BasicSelect({ name, value, options, setValue,
  minWidth = 120,
  textColor = "inherit", 
  borderColor = "inherit", 
  iconColor = "inherit",
  hoverBorderColor = "inherit",
  size ="small"
 }) {
  const handleChange = (event) => {
    setValue(event.target.value);
  };

  return (
    <FormControl 
    size = {size}
    sx={{ 
      // marginLeft: 
      // 1, 
   
      minWidth,
      //  marginBottom:1,
       "& .MuiOutlinedInput-root": {
        color: textColor, // Text color
        borderColor, // Border color
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor, // Border color for the outline
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor, // Border color on hover
      },
      "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
        borderColor: hoverBorderColor, // Border color on hover
      },

      "& .Mui-focused": {
        color: textColor, // Text color
      },
       }}>
      <InputLabel id='demo-simple-select-label'
       sx={{ color: textColor }}
      >{name}</InputLabel>
      <Select
        labelId='demo-simple-select-label'
        id='demo-simple-select'
        value={value}
        label={name}
        onChange={handleChange}
        sx={{
          "& .MuiSelect-icon": {
            color: iconColor, 
          },
        }}
      >
        {options.map((option) => (
          <MenuItem value={option}>{option}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
